export var FavoriteUserListName;
(function (FavoriteUserListName) {
    FavoriteUserListName["USERS"] = "users";
    FavoriteUserListName["LOCAL_ACCOUNTS"] = "local_accounts";
    FavoriteUserListName["EXCHANGES"] = "exchanges";
})(FavoriteUserListName || (FavoriteUserListName = {}));
